export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-secondary-100/40">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center shadow-lg shadow-primary-200/30">
            <i className="ri-smartphone-line text-6xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              移动阅读
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-lg">
              亲亲漫画移动端适配完善，无论手机还是平板，都能享受流畅的下拉式阅读体验。随时随地追更韩漫、日漫、国漫热门推荐，免费全集在线看，好看的漫画尽在掌握。
            </p>
            <div className="mt-5 flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 版
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 版
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-computer-line"></i>
                网页版
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}